import api from "../index";

export const GetActiveEducationMaterialsApi = () =>
    api.get("KnowledgeHub/get-active-education-materials");

export const GetEducationSectionsApi = (materialId) =>
    api.get(`KnowledgeHub/get-active-education-sections/${materialId}`);

export const GetUserProgressApi = (materialId) =>
    api.get(`KnowledgeHub/get-user-progress/${materialId}`);

export const GetActiveEducationUnitsApi = (sectionId) =>
    api.get(`KnowledgeHub/get-active-education-units/${sectionId}`);

export const MarkAsCompletedUnitApi = (payload) =>
    api.post("KnowledgeHub/mark-as-completed-unit", payload);
